import { DeliveryAreaPayload, productsPayload } from "app/types";
import {
  GetDeliveryShiftRestrictionsApiResponse,
  PutDeliveryShiftRestrictionsApiResponse,
  PutDeliveryShiftRestrictionsPayload,
} from "app/types/deliveryShiftConfiguration";
import type { GetCountryDistrictsApiResponse } from "app/types/countryDistrictsApi";
import { AxiosResponse } from "axios";
import axios from "./config";

export const getCountriesAPI = () => axios.get(`/Countries`);

export const getZonesAPI = (countryId: number) =>
  axios.get(`/zones?countryId=${countryId}`);

export const postZonesAPI = (payload: { Name: string }) =>
  axios.post(`/zones`, payload);

export const putZonesAPI = (zoneId: number, payload: { Name: string }) =>
  axios.put(`/zones/${zoneId}`, payload);

export const putAreaAPI = (
  governarateId: number,
  districtId: number,
  payload: DeliveryAreaPayload
) => axios.put(`/governates/${governarateId}/Districts/${districtId}`, payload);

export const getCountriesById = (id: number) => axios.get(`/Countries/${id}`);

export const createDeliveryAreaAPI = (
  governateId: number,
  payload: DeliveryAreaPayload
) => axios.post(`/governates/${governateId}/Districts`, payload);

export const getDeliveryAreaAPI = (
  countryId: number,
): Promise<AxiosResponse<GetCountryDistrictsApiResponse>> =>
  axios.get<GetCountryDistrictsApiResponse>(
    `/countries/${countryId}/districts`,
  );

export const getDeliveryShiftRestrictionsAPI = (
  storeId: number,
): Promise<AxiosResponse<GetDeliveryShiftRestrictionsApiResponse>> =>
  axios.get<GetDeliveryShiftRestrictionsApiResponse>(
    `/stores/${storeId}/delivery-shift-restrictions`,
  );

export const putDeliveryShiftRestrictionsAPI = (
  storeId: number,
  deliveryShiftId: number,
  payload: PutDeliveryShiftRestrictionsPayload,
): Promise<AxiosResponse<PutDeliveryShiftRestrictionsApiResponse>> =>
  axios.put<PutDeliveryShiftRestrictionsApiResponse>(
    `/stores/${storeId}/delivery-shifts/${deliveryShiftId}/restrictions`,
    payload,
  );

export const getGovernateApI = (provinceId: number) =>
  axios.get(`/Provinces/${provinceId}/Governates`);

export const getProvincesApI = (countryId: number) =>
  axios.get(`/Countries/${countryId}/Provinces`);

export const getProductsApI = (
  storeId: number | string,
  branchId: number,
  payload: any
) => axios.get(`/stores/${storeId}/branches/${branchId}/products${payload}`);

export const addStocksAPI = (
  storeId: number | string,
  branchId: number,
  productId: number,
  payload: productsPayload
) =>
  axios.post(
    `/stores/${storeId}/branches/${branchId}/products/${productId}/stocks`,
    payload
  );
